<template>
  <div class="result pb-md-16">
    <!-- ステータスによって切り替わるテキスト/ 三菱は達成賞という概念がないため非表示となる -->
    <!-- <div
      v-if="campaignUser.is_prizewinner && !isContinueBonusComp"
      class="c-result-status-bar--clear c-custom--w-100 py-3 font-weight-bold white--text text-center"
    >
      <div>達成賞獲得！！</div>
    </div>
    <div
      v-if="campaignUser.is_prizewinner && isContinueBonusComp"
      class="c-result-status-bar--allclear c-custom--w-100 py-3 font-weight-bold white--text text-center"
    >
      <div>達成賞&継続ボーナス獲得！！</div>
    </div> -->

    <!-- SPのみ 記録開始日（00/00）以降に入力欄が表示され、記録の入力が可能になります。 -->
    <div v-if="isMobile && !isLoading && !isCampaignStarted" class="result-top-is-preparation d-flex align-center pa-4 font-weight-bold text-center">
      記録開始日（{{this.formatStartDate}}）以降に入力欄が表示され、記録の入力が可能になります。
    </div>

    <!-- ローディング -->
    <div v-if="isLoading" class="text-center mt-10 mb-10">
      <v-progress-circular indeterminate color="secondary" />
    </div>
    <div v-if="isSavingMobileAppHealthData" class="text-center mt-10 mb-10 result-top-loading-mobile-app">
      <div style="background-color: rgba(255, 255, 255, 0.92); padding: 5px;">
        <v-progress-circular indeterminate color="secondary"/>
        <div style="font-size: 13px;">ヘルスデータを保存しています</div>
      </div>
    </div>

    <!-- コースクリア率、カルーセル -->
    <div v-if="!isLoading" class="result__inner pt-16 pt-md-13 mb-15">
      <div
        class="result-top-course__row"
      >
        <div
          class="result-top-course__col--clear"
        >
        <!-- コースクリア率 -->
          <div>
            <p class="c-result-title-size font-weight-bold">コースクリア率</p>
            <div
              class="result-circle"
            >
              <div
                v-for="(course) in this.dailyValueList.select_course_list"
                :key="course.id"
                class="result-circle__col"
              >
                <svg viewBox='0 0 36 36'>
                  <!-- SVGのグラデーション指定 -->
                  <defs>
                    <linearGradient id="svg_config_gradient" x1="1" x2="0" y1="0" y2="0">
                      <stop offset="0%" stop-color="#73D0FF" />
                      <stop offset="100%" stop-color="#139BDF" />
                    </linearGradient>
                  </defs>
                  <!-- 円グラフ -->
                  <circle cx='18' cy='18' r='13.5' fill='none' stroke='#EAF6F7' stroke-width='9' />
                  <circle v-if="calculateClearRate(course) > 0" cx='18' cy='18' r='13.5' fill='none' stroke='url(#svg_config_gradient)' stroke-width='9'
                    :stroke-dasharray="`${calculateClearRate(course)}, ${calculateRemainingClearRate(course)}`" stroke-linecap='round' transform='rotate(-90 18 18)' />
                </svg>
                <p class="pt-3 text-center font-weight-bold">{{course.name}}</p>
                <p
                  v-if="!isMobile && course.aggregate_result_info.is_completed"
                  class="is-clear ma-0"
                >
                  <img src="/image/badge/clear.png" alt="達成">
                </p>
              </div>
            </div>
            <div
              class="c-custom--w-100 mt-2 mt-md-0 text-center"
            >
              <v-btn
                @click="showCourseClearDialog = true"
                rounded
                x-large
                elevation="0"
                class="c-result-btn--blue result-circle-btn c-custom--w-100 font-weight-bold text-center"
                v-if="isCampaignStarted"
              >
                <span>達成状況の詳細</span>
              </v-btn>
            </div>
            <v-dialog
              v-model="showCourseClearDialog"
              scrollable
              :max-width="1200"
              class="c-custom--v-dialog"
            >
              <v-card outlined>
                <v-btn
                  fab
                  small
                  elevation="0"
                  @click="showCourseClearDialog = false"
                  class="c-result-dialog-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-text
                  class="c-custom--v-card-text"
                >
                  <ResultTopicConfirm :campaignUser="campaignUser" :propsDailyValueList="dailyValueList" />
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </div>
        <!-- 画像カルーセル -->
        <div
          v-if="!isMobile"
          class="result-top-course__col--carousel"
        >
          <ResultTopicCarousel :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
        </div>
      </div>
    </div>

    <!-- PC時 ウォーキング、ボーナス、順位 -->
    <div v-if="!isLoading" class="result-top-infos result__inner mb-md-15">
      <div class="result-top-infos__row d-flex justify-center">
        <!-- ウォーキングラリー -->
        <div
          v-if="!isMobile && campaignOption.is_walking_travel && isSelectedWalkingCourse"
          class="result-top-infos__walking result-top-infos__col"
        >
          <ResultTopicWalking :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
        </div>
        <!-- 継続ボーナス -->
        <div
          v-if="campaign.is_continue_bonus && campaignUser.course"
          class="result-top-infos__clover result-top-infos__col"
        >
          <ResultTopicClover :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
        </div>
        <!-- 現在の順位 -->
        <div
          v-if="!isMobile"
          class="result-top-infos__userinfo result-top-infos__col"
        >
          <ResultTopicUserInfo :campaignUser="campaignUser" :isTeam="campaign.is_team"/>
        </div>
      </div>
    </div>

    <!-- PCのみ 記録開始日（00/00）以降に入力欄が表示され、記録の入力が可能になります。 -->
    <div v-if="!isMobile && !isLoading && !isCampaignStarted" class="result-top-is-preparation d-flex align-center pl-4 font-weight-bold">
      記録開始日（{{this.formatStartDate}}）以降に入力欄が表示され、記録の入力が可能になります。
    </div>

    <!-- 記入するテーブル -->
    <div
      ref="record_area"
      class="result__inner"
      v-if="isCampaignStarted"
    >
      <ResultInput
        @fetchData="getDailyResultList" @submit="changeIsSubmitting" @change="changeHasChange" @inputError="inputError"
        @saveSuccess="saveSuccess" @saveSuccessFromSaveMobileAppHealthData="saveSuccessFromSaveMobileAppHealthData"
        @saveInputError="saveInputError" @changeShowHasChange="changeShowHasChange"
        @changeIsSavingMobileAppHealthData="changeIsSavingMobileAppHealthData"
        :campaignUser="campaignUser" :propsDailyValueList="dailyValueList" :propsIsLoading="isLoading"
        ref="resultInput"
      />
    </div>

    <!-- SP時 順位、ウォーキング、カルーセル、下線 -->
    <v-row
      v-if="isMobile && !isLoading"
      no-gutters
      class="result__inner"
    >
      <v-col
        cols="12"
        class=""
      >
        <ResultTopicUserInfo :campaignUser="campaignUser" :isTeam="campaign.is_team"/>
      </v-col>
      <v-col
        cols="12"
        class="mt-4"
      >
        <ResultTopicWalking :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
      </v-col>
      <v-col
        cols="12"
        class="mt-13 mb-16 pb-10"
      >
        <ResultTopicCarousel :campaignUser="campaignUser" :isSelectedWalkingCourse="isSelectedWalkingCourse" :dailyValueList="dailyValueList" :numberOfSteps="numberOfSteps"/>
      </v-col>
    </v-row>
    <v-sheet v-if="isMobile && !isLoading" class="result-top-under" color="primary"></v-sheet>

    <!-- 入力するボタン -->
    <div
      v-if="isCampaignPeriod"
      class="result-top-record"
    >
      <v-btn
        v-if="!isMobile"
        @click="scrollToAnchorPoint('record_area')"
        elevation="0"
        class="result-top-btn--record c-custom--w-100 font-weight-bold"
      >
        <span class="result-top-btn-block">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.6852 2.19558C25.9962 2.06646 26.3296 2 26.6664 2C27.0031 2 27.3366 2.06646 27.6476 2.19558C27.9586 2.3247 28.2411 2.51394 28.4788 2.75244L28.48 2.75356L30.7464 5.02003L30.7475 5.02115C30.986 5.25889 31.1753 5.54137 31.3044 5.85239C31.4335 6.16341 31.5 6.49686 31.5 6.83361C31.5 7.17036 31.4335 7.50381 31.3044 7.81483C31.1753 8.12585 30.986 8.40832 30.7475 8.64606L30.7464 8.64719L9.67441 29.7192L2.30045 31.1996L3.78081 23.8255L24.8528 2.75356L24.8539 2.75244C25.0917 2.51393 25.3741 2.3247 25.6852 2.19558ZM1.98552 22.8465C1.93235 22.942 1.89605 23.0445 1.87663 23.1495L0.0438701 32.2789C-0.0219902 32.6069 0.0805965 32.9462 0.317202 33.1828C0.553807 33.4194 0.893071 33.522 1.22114 33.4561L10.3519 31.6231C10.4461 31.6055 10.5382 31.5744 10.6252 31.5297C10.723 31.4794 10.8104 31.414 10.8851 31.3369L32.1595 10.0625L32.1601 10.0619C32.5847 9.63848 32.9216 9.13547 33.1516 8.58167C33.3816 8.02758 33.5 7.43355 33.5 6.83361C33.5 6.23367 33.3816 5.63964 33.1516 5.08555C32.9216 4.53171 32.5847 4.02867 32.1601 3.60524L32.1595 3.60469L29.8953 1.34048L29.8945 1.33971C29.4711 0.915175 28.9682 0.578321 28.4144 0.348434C27.8603 0.118407 27.2663 0 26.6664 0C26.0664 0 25.4724 0.118407 24.9183 0.348434C24.3643 0.578447 23.8611 0.915544 23.4375 1.3404L23.4375 1.34048L2.16186 22.6161C2.09288 22.6832 2.03321 22.7606 1.98552 22.8465Z" fill="black"/>
          </svg>
          入力する
        </span>
      </v-btn>

      <v-btn
        v-if="isMobile"
        @click="callSetDateValueForSP()"
        elevation="0"
        class="result-top-btn--record c-custom--w-100 font-weight-bold"
      >
        <span class="result-top-btn-block">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5993 2.63438C20.8134 2.54551 21.0429 2.49976 21.2747 2.49976L24.4978 7.01347C24.4348 7.10654 24.3629 7.19358 24.2829 7.27331L24.2818 7.27444L7.98071 23.5755L2.65612 24.6444L3.72505 19.3198L20.0261 3.01878L20.0272 3.01765C20.1909 2.85349 20.3853 2.72325 20.5993 2.63438ZM1.9224 18.3542C1.87338 18.4457 1.8396 18.5431 1.82106 18.6428L0.399537 25.7237C0.333677 26.0518 0.436264 26.3911 0.672869 26.6277C0.909474 26.8643 1.24874 26.9669 1.5768 26.901L8.65844 25.4793C8.75297 25.4617 8.84546 25.4303 8.93269 25.3853C9.02988 25.3352 9.11684 25.2701 9.19114 25.1935L25.6948 8.68978L24.4978 7.01347C24.4981 7.01313 24.4983 7.0128 24.4985 7.01246L25.696 8.68865C26.046 8.33945 26.3237 7.92467 26.5133 7.46803C26.7031 7.0109 26.8008 6.5208 26.8008 6.02584C26.8008 5.53088 26.7031 5.04078 26.5133 4.58365C26.3236 4.12676 26.0457 3.71178 25.6954 3.36246L25.6948 3.3619L23.9386 1.60569L23.9385 1.60557C23.5891 1.25508 23.174 0.976986 22.7169 0.78723C22.2598 0.597452 21.7697 0.499763 21.2747 0.499763C20.7797 0.499763 20.2896 0.597452 19.8325 0.78723C19.3757 0.976874 18.9608 1.25475 18.6115 1.60495L18.6108 1.60569L2.10643 18.11C2.03372 18.1807 1.97134 18.2628 1.9224 18.3542ZM24.4985 7.01246L21.2747 2.49976C21.5065 2.49976 21.736 2.54551 21.95 2.63438C22.1641 2.72325 22.3585 2.85349 22.5222 3.01765L22.5233 3.01878L24.2818 4.77724L24.2829 4.77837C24.447 4.942 24.5773 5.13642 24.6662 5.35049C24.755 5.56456 24.8008 5.79406 24.8008 6.02584C24.8008 6.25762 24.755 6.48712 24.6662 6.70119C24.6208 6.81057 24.5645 6.91482 24.4985 7.01246Z" fill="black"/>
          </svg>
          入力する
        </span>
      </v-btn>
    </div>

    <!-- PC時 ページ下部固定ボタン群 -->
    <div
      v-if="!isMobile && isCampaignStarted"
      class="result-top-buttons c-custom--w-100 py-5"
    >
      <ul class="result-top-buttons__row d-flex justify-center align-center">
        <li class="result-top-buttons__col result-top-buttons__storage">
          <v-btn
            rounded
            x-large
            elevation="0"
            class="c-result-btn--storage result-top-btn--storage c-custom--w-100 font-weight-bold"
            style="background-color: #FFE34F !important;"
            @click="saveClick()"
            :disabled="!hasChange"
            :loading="isSubmitting"
            >
            <span>保存する</span>
          </v-btn>
        </li>
        <li class="result-top-buttons__col result-top-buttons__csv">
          <v-btn
            @click="csvClick()"
            rounded
            x-large
            elevation="0"
            color="white"
            class="result-top-btn--csv c-custom--w-100 py-4 font-weight-bold"
            :loading="isSubmitting"
          >
            <span>CSV出力</span>
          </v-btn>
        </li>
      </ul>
    </div>

    <!-- アラート -->
    <v-alert
      v-if="isSaveInputError"
      class="result-top-alert--error text-center">
      <span class="font-weight-bold">入力内容にエラーがあります。確認してください。</span>
    </v-alert>
    <v-alert
      v-if="isSaveSuccess"
      class="result-top-alert--clear text-center">
      <span class="font-weight-bold">結果記録が保存されました</span>
    </v-alert>
    <v-alert
      v-if="isSaveSuccessFromSaveMobileAppHealthData"
      class="result-top-alert--clear text-center">
      <span class="font-weight-bold">ヘルスケア/ヘルスコネクトから結果記録が保存されました</span>
    </v-alert>
    <v-alert
      v-if="showHasChange"
      class="result-top-alert--urge text-center">
      <span class="font-weight-bold">入力をしたら、「保存する」ボタンを押してください</span>
    </v-alert>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'
const ResultTopicClover = () => import('./ResultTopicClover')
const ResultTopicWalking = () => import('./ResultTopicWalking')
const ResultTopicCarousel = () => import('./ResultTopicCarousel')
const ResultTopicUserInfo = () => import('./ResultTopicUserInfo')
const ResultTopicConfirm = () => import('./ResultTopicConfirm')
const ResultInput = () => import('./ResultInput')

const listDailyResultQuery = (campaignId) => `
  query listDailyResult {
    listDailyResult(campaign_id: "${campaignId}") {
      campaign_id
      select_course_list {
        id
        meta
        name
        result_type
        unit
        complete_type
        complete_value
        category
        objective
        basic_item
        recording_method
        detailed_document_file_name
        youtube_url
        youtube_thumbnail_file_name
        aggregate
        participants
        is_display_graph
        custom_goal_setting
        aggregate_result_info {
          id
          course_id
          point
          input_count
          total
          average
          rank
          custom_objective
          clear_count
          is_completed
        }
      }
      daily_results {
        id
        meta
        is_inputted
        top_blood_pressure
        bottom_blood_pressure
        note
        select_course_result {
          id
          meta
          course_id
          circle_and_cross
          integer
          number
          is_manual
        }
      }
    }
  }
`
const getListDailyResult = async (campaignId) => {
  const { data: { listDailyResult: data } } = await GraphqlAPI(listDailyResultQuery(campaignId))
  return data
}

const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      is_app_completed
      is_no_smoking_completed
      is_continue_bonus_complete
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return {
    is_app_completed: data.is_app_completed,
    is_no_smoking_completed: data.is_no_smoking_completed,
    is_continue_bonus_complete: data.is_continue_bonus_complete
  }
}

const getCampaignUserQuery = (campaignId) => `
  query getCampaignUser {
    getCampaignUser(campaign_id: "${campaignId}") {
      mobile_app_last_signin_at
    }
  }
`
const getCampaignUser = async (campaignId) => {
  const { data: { getCampaignUser: data } } = await GraphqlAPI(getCampaignUserQuery(campaignId))
  return data
}

const updateIsMobileAppUsedMutation = (campaignId, isMobileAppUsed) => `
  mutation updateIsMobileAppUsed {
    updateIsMobileAppUsed(
      campaign_id: "${campaignId}",
      is_mobile_app_used: ${isMobileAppUsed}
    ) {
      id
    }
  }
`
const updateIsMobileAppUsed = async (campaignId, isMobileAppUsed) => {
  const { data: { updateIsMobileAppUsed: data } } = await GraphqlAPI(updateIsMobileAppUsedMutation(campaignId, isMobileAppUsed))
  return data
}

const isUnixTimestampToday = (unixTimestamp) => {
  if (unixTimestamp == null) return false
  return dayjs.unix(unixTimestamp).isSame(dayjs(), 'day')
}

export default {
  name: 'result',
  data () {
    return {
      hasChange: false,
      isSubmitting: false,
      isLoading: false,
      tab: null,
      dailyValueList: null,
      showSnackBar: false,
      message: null,
      isAppPrizewinner: false,
      isContinueBonusComp: false,
      isSelectedWalkingCourse: false,
      numberOfSteps: 0,
      normalNumberOfStepsWhenContinue: 0,
      showCourseClearDialog: false, // コースクリア率の詳細ダイアログ
      formatStartDate: null,
      startDate: null,
      isSaveSuccess: false,
      isSaveSuccessFromSaveMobileAppHealthData: false,
      isSaveInputError: false,
      showHasChange: false,
      isSavingMobileAppHealthData: false
    }
  },
  props: ['campaignUser'],
  components: {
    ResultTopicClover,
    ResultTopicWalking,
    ResultTopicCarousel,
    ResultTopicUserInfo,
    ResultTopicConfirm,
    ResultInput
  },
  computed: {
    continueBonusHistorys () {
      return this.$store.getters.getContinueBonusHistorys
    },
    continueBonus () {
      return this.$store.getters.getContinueBonus
    },
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    isRegisteredCourse () {
      return this.$store.getters.getRegisteredCourse
    },
    isMobile () { // モバイル判定
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    },
    isCampaignStarted () {
      return new Date(this.campaign.start) <= new Date()
    },
    isCampaignPeriod () {
      const siteCloseDate = new Date(this.campaign.site_close)
      siteCloseDate.setDate(siteCloseDate.getDate() + 1)
      return new Date(this.campaign.start) <= new Date() && new Date() < siteCloseDate
    }
  },
  watch: {
    dailyValueList: {
      handler (newValue) {
        if (newValue !== null) {
          for (const course of this.dailyValueList.select_course_list) {
            if (course.unit === '歩' &&
              course.aggregate_result_info.total !== null &&
              this.numberOfSteps !== course.aggregate_result_info.total
            ) {
              this.numberOfSteps = course.aggregate_result_info.total
            }
          }
          if (this.$store.getters.getCampaign.is_continuity) {
            this.numberOfSteps += this.normalNumberOfStepsWhenContinue
          }
        }
      },
      deep: true
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isLoading = true
    await this.fetchUserViewData()
    await this.fetchListDailyResult()
    if (this.$store.getters.getIsMobileApp && !this.$store.getters.getNeedsSaveHealthDataFromMobileApp) {
      await this.updateIsMobileAppUsedWhenNotSignedInToday()
    }
    this.isLoading = false
    this.formatStartDate = dayjs(this.campaign.start, 'YYYY-MM-DD').format('M/D')
    // 継続ボーナス判定
  },
  async mounted () {
    // 指定ページからの遷移後処理
    if (this.$route.params.referer) {
      if (this.$route.params.referer === 'update_course') {
        this.message = 'コースが保存されました。'
        this.showSnackBar = true
        this.$route.params.referer = ''
      } else if (this.$route.params.referer === 'app_entry') {
        this.message = '食事バッチリ！アプリチャレンジコースにエントリーしました。'
        this.showSnackBar = true
        this.$route.params.referer = ''
      }
    }
  },
  methods: {
    saveClick () {
      this.$refs.resultInput.save()
    },
    csvClick () {
      this.$refs.resultInput.csvLine()
    },
    calculateClearRate (course) {
      const clearCount = course.aggregate_result_info.clear_count
      const totalCount = course.complete_value
      return totalCount !== 0 ? Math.floor((clearCount / totalCount) * 100) : 0
    },
    calculateRemainingClearRate (course) {
      const clearRate = this.calculateClearRate(course)
      return 100 - clearRate
    },
    async fetchListDailyResult () {
      try {
        this.dailyValueList = await getListDailyResult(this.campaign.id)
        for (const course of this.dailyValueList.select_course_list) {
          // ウォーキングコースの有無取得
          if (course.unit === '歩') {
            this.isSelectedWalkingCourse = true
            if (course.aggregate_result_info.total !== null) {
              this.numberOfSteps = course.aggregate_result_info.total
            }
          }
        }
        // 現在のキャンペーンが継続版のとき、通常版（継続版の関連キャンペーン）の歩数を取得して合算する
        if (this.$store.getters.getCampaign.is_continuity) {
          try {
            const normalDailyValueList = await getListDailyResult(this.$store.getters.getRelationalCampaign.id)
            const normalWalkingCourse = normalDailyValueList.select_course_list.find(course => course.unit === '歩')
            if (normalWalkingCourse && normalWalkingCourse.aggregate_result_info.total !== null) {
              this.normalNumberOfStepsWhenContinue = normalWalkingCourse.aggregate_result_info.total
              this.numberOfSteps += this.normalNumberOfStepsWhenContinue
            }
          } catch (e) {
            // 通常版に未参加の場合は合算せず継続版の歩数のみとする
            if (e.errors[0].message !== 'campaign_user not found or select course is None') {
              throw e
            }
          }
        }
      } catch (e) {
        this.$emit('errorHandling', '結果の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async fetchUserViewData () {
      try {
        const userviewInfo = await getUserViewInfo(this.campaign.id)
        this.isAppPrizewinner = userviewInfo.is_app_completed || userviewInfo.is_no_smoking_completed
        this.isContinueBonusComp = userviewInfo.is_continue_bonus_complete
      } catch (e) {
        this.$emit('errorHandling', '達成賞対象情報の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async updateIsMobileAppUsedWhenNotSignedInToday () {
      try {
        const campaignUser = await getCampaignUser(this.campaign.id)
        // モバイルアプリ最終サインイン日時が同日の場合は更新しない
        if (isUnixTimestampToday(campaignUser.mobile_app_last_signin_at)) {
          return
        }
        await updateIsMobileAppUsed(this.campaign.id, true)
      } catch (e) {
        this.$emit('errorHandling', 'アプリ利用情報の更新に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    async getDailyResultList (childFunction) {
      try {
        this.dailyValueList = await getListDailyResult(this.campaign.id)
        this.$emit('fetchCampaignUser')
        childFunction()
      } catch (e) {
        this.$emit('errorHandling', '結果の取得に失敗しました。' + e.errors[0].message)
        this.$log.debug(e)
      }
    },
    saveSuccess () { // 結果記録保存成功時alert表示
      this.isSaveSuccess = true
      setTimeout(() => {
        this.isSaveSuccess = false
      }, 5000) // 5秒後非表示
    },
    saveSuccessFromSaveMobileAppHealthData () { // モバイルアプリヘルスデータ自動保存成功時alert表示
      this.isSavingMobileAppHealthData = false
      this.isSubmitting = false
      this.isSaveSuccessFromSaveMobileAppHealthData = true
      setTimeout(() => {
        this.isSaveSuccessFromSaveMobileAppHealthData = false
      }, 5000) // 5秒後非表示
    },
    changeIsSavingMobileAppHealthData (isSavingMobileAppHealthData) { // モバイルアプリヘルスデータ連携用ローディング制御
      this.isSavingMobileAppHealthData = isSavingMobileAppHealthData
    },
    saveInputError (hasError) { // 入力内容エラーalert表示
      this.isSaveInputError = hasError
    },
    changeShowHasChange (showHasChange) {
      this.showHasChange = showHasChange
    },
    changeHasChange (hasChange) {
      this.hasChange = hasChange
    },
    changeIsSubmitting (isSubmitting) {
      this.isSubmitting = isSubmitting
    },
    inputError (errorMessage) {
      this.$emit('errorHandling', errorMessage)
    },
    // スムーススクロール（PC：入力するボタン）
    scrollToAnchorPoint (refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth' })
    },
    // 入力画面モーダル表示（SP：入力するボタン）
    callSetDateValueForSP () {
      let formatDate
      if (new Date() <= new Date(this.campaign.end)) {
        formatDate = dayjs(new Date()).format('YYYY-MM-DD')
      } else {
        formatDate = dayjs(new Date(this.campaign.end)).format('YYYY-MM-DD')
      }
      this.$refs.resultInput.setDateValueForSP(formatDate)
    }
  }
}
</script>

<style lang="scss">
/* 共通用 => .c-result-◯◯◯◯ // .c-result-top-◯◯◯◯ */
$result-font-size-title-pc: 20px;
$result-font-size-title-sp: 18px;
$result-border-radius: 8px;
$result-color-blue: #19ADF8;

.c-result-font-roboto--500 {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
}
.c-result-text-color--blue {
  color: $result-color-blue;
}
.c-result-title-size {
  font-size: $result-font-size-title-sp;
  @media screen and (min-width: 960px) {
    font-size: $result-font-size-title-pc;
  }
}
.c-result-btn--gray {
  color: $result-color-blue !important;
  font-size: 14px !important;
  letter-spacing: 0;
  background-color: #f5f5f5 !important;

  @media screen and (min-width: 960px) {
    font-size: 16px !important;
  }

  &.c-result-btn--gray--modal {
    font-size: calc(14 / 390 * 100vw) !important;
    @media screen and (min-width: 960px) {
      font-size: 16px !important;
    }
  }
}
.c-result-btn--blue {
  color: #fff !important;
  font-size: 14px !important;
  letter-spacing: 0;
  background-color: $result-color-blue !important;

  @media screen and (min-width: 960px) {
    font-size: 16px !important;
  }
}
.c-result-btn--storage {
  background-color: #FFE34F !important;
}
.c-result-dialog-card {
  padding: 24px 20px;
  border: 1px #ccc solid;
  border-radius: $result-border-radius !important;
  background-color: #fff;
}
.c-result-top-infos__col--gray {
  padding: 24px !important;
  border: 1px #ccc solid !important;
}
.c-result-top-infos__col--green {
  padding: 16px;
  border: 16px solid #E0F2EB !important;
}
.c-result-top-infos__col--radius {
  overflow: hidden;
  border-radius: $result-border-radius !important;
}

/* ページ上部のステータスバー 「達成賞獲得！」「達成賞＆達成ボーナス獲得！！」 */
@mixin result-status-bar($result-status-bar-bg-color) {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  background: $result-status-bar-bg-color;

  @media screen and (min-width: 960px) {
    font-size: 18px;
  }
}
.c-result-status-bar--clear { // 達成賞獲得！
  @include result-status-bar(#3DCEBB);
}

.c-result-status-bar--allclear { // 達成賞＆達成ボーナス獲得！！
  @include result-status-bar(linear-gradient(90deg, #73D0FF 42.44%, #139BDF 73.08%));
}

/* vuetify 無くなったものを追加 => .c-custom--◯◯◯◯ */
.c-custom--w-100 {
  width: 100%;
}
.c-custom--h-100 {
  height: 100%;
}

/* v-alert 上書き => &.c-custom--v-alert のみ */
.v-alert {
  &.c-custom--v-alert {
    .v-alert__wrapper {
      height: 100%;

      .v-alert__content {
        height: 100%;
      }
    }
  }
}

/* v-window 上書き => &.c-custom--v-window のみ */
.v-window {
  &.c-custom--v-window {
    .v-window__prev, .v-window__next {
      background: rgba(0,0,0,0) !important;
    }
    .v-window__prev {
      left: -15px !important;
    }
    .v-window__next {
      right: -15px !important;
    }
    .v-window-item {
      width: 86%;
      margin: 0 auto;
    }
  }
}

/* v-dialog 上書き */
.v-overlay {
  &.v-overlay--active {
    .v-overlay__scrim { // overlay
      opacity: 1 !important;
      background-color: rgba(240, 245, 245, 0.80) !important;
      backdrop-filter: blur(10px);
    }
  }
}
.v-dialog {
  &.v-dialog--active {
    box-shadow: none;
    .theme--light.v-card,
    .theme--light.v-toolbar.v-sheet {
      background-color: rgba(255,255,255,0);
    }
    .theme--light.v-sheet--outlined {
      border: none;
    }
    .theme--light.v-btn.v-btn--has-bg {
      background-color: rgba(255,255,255,0);
    }
    .v-btn {
      &.c-result-dialog-close-btn {
        margin: 0 0 0 auto;
      }
    }
  }
  .v-card {
    .v-card__text {
      &.c-custom--v-card-text {
        @media screen and (max-width: 959px) {
          padding: 0 !important;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
/* コースクリア率とカルーセル */
.result-top-course__row {
  display: block;

  @media screen and (min-width: 960px) {
    display: flex;
    justify-content: center;
    gap: 35px;
  }

  .result-top-course__col--clear {
    width: 100%;
    max-width: inherit;

    @media screen and (min-width: 960px) {
      width: auto;
      // width: 70%;
      // max-width: 900px;
    }
  }
  .result-top-course__col--carousel {
    width: 100%;
    max-width: inherit;

    @media screen and (min-width: 960px) {
      width: 30%;
      max-width: 386px;
    }
  }
}

/* コースクリア率 => .result-circle // .result-circle-btn */
.result-circle {
  display: flex;
  justify-content: center;
  // flex-wrap: wrap;
  gap: 0 4vw;
  font-size: 11px;

  @media screen and (min-width: 960px) {
    gap: 0 min(2.4vw, 36px); // 0 5%;
    font-size: 16px;
  }

  .result-circle__col {
    position: relative;
    width: calc(100vw / 5);
    max-width: 100px;
    overflow-wrap: anywhere;

    @media screen and (min-width: 960px) {
      width: 11vw; // calc(100% / 5)
      max-width: 136px;
    }

    .is-clear {
      position: absolute;
      left: 0;
      top: 0;
      width: 30%;
      min-width: 33px;
      height: auto;

      img {
        width: 100%;
      }
    }
  }
}
.v-btn {
  &.result-circle-btn {
    width: 90%;
    max-width: 146px;

    @media screen and (min-width: 960px) {
      width: 100%;
      max-width: 192px;
    }
  }
}

/* PC時のウォーキング、ボーナス、順位の部分。TOPでのみ使用 => .result-top-infos-◯◯◯◯ */
.result-top-infos {
  .result-top-infos__row {
    flex-wrap: wrap;
    gap: 10px;
    @media screen and (min-width: 1611px) {
      flex-wrap: nowrap;
    }
    .result-top-infos__col {
      &.result-top-infos__walking {
        width: 85%;
        max-width: inherit;

        @media screen and (min-width: 1611px) {
          width: 70%;
          max-width: 700px;
        }
      }
      &.result-top-infos__clover {
        width: 100%;
        @media screen and (min-width: 1611px) {
          /* 1611 < */
          min-width: 430px;
          max-width: 470px;
          width: 47%;
        }
        @media screen and (max-width: 1610px) and (min-width: 960px) {
          /* 1610 > 960 */
          min-width: inherit;
          max-width: inherit;
          width: 52%;
        }
      }
      &.result-top-infos__userinfo {
        min-width: inherit;
        max-width: inherit;
        width: 32%;

        @media screen and (min-width: 1611px) {
          width: 20% ;
          min-width: 300px;
          max-width: 300px;
        }
      }
    }
  }
}

/* SP時のページ下部の線。TOPでのみ使用 => .result-top-under-◯◯◯◯ */
.result-top-under {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 37px;
  background-color: #3DCEBB;
}

/* PC時のページ下部のボタン群。TOPでのみ使用 => .result-top-buttons-◯◯◯◯ */
.result-top-buttons {
  position: fixed;
  left: 0;
  bottom: 0; // 固定フッターの「健康チャレンジキャンペーン」の箇所がある場合は、20pxに変更
  z-index: 4;
  background-color: #F5F5F5;

  .result-top-buttons__row {
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 20px;

    .result-top-buttons__col {
      &.result-top-buttons__storage {
        width: min(25% , 300px);
      }
      &.result-top-buttons__csv {
        width: min(25% , 300px);
      }
    }
  }
  .v-btn {
    &.result-top-btn--storage {
    }
    &.result-top-btn--csv {
    }
  }
}

/* ページ下部の記入するボタン。TOPでのみ使用 => .result-top-record-◯◯◯◯ */
.result-top-record {
  position: fixed;
  right: 20px;
  bottom: 60px; // 固定フッターの「健康チャレンジキャンペーン」の箇所がある場合は、適宜変更
  z-index: 2;

  @media screen and (min-width: 960px) {
    right: 40px;
    bottom: 140px;
  }
  .v-btn {
    &.result-top-btn--record {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      background-color: #FFE34F;
      filter: drop-shadow(0px 4px 10px rgba(25, 60, 77, 0.20));

      @media screen and (min-width: 960px) {
        width: 116px;
        height: 116px;
        font-size: 14px;
      }

      .result-top-btn-block {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 2px 0;
        letter-spacing: 0;

        @media screen and (min-width: 960px) {
          gap: 7px 0;
        }

        svg {
          width: 27px;
          height: 27px;

          @media screen and (min-width: 960px) {
            width: 34px;
            height: 34px;
          }
        }
      }
    }
  }
}

/* ページ下部に出現するアラート。TOPでのみ使用 => .c-result-top-alert-◯◯◯◯ */
@mixin result-top-alert($result-top-alert-text-color, $result-top-alert-bg-color) {
  position: fixed;
  left: 50%;
  bottom: 52px;
  transform: translateX(-50%);
  z-index: 2;
  width: 92%;
  padding: 0 !important;
  margin: 0 !important;
  background-color: rgba(255,255,255,0) !important;

  @media screen and (min-width: 960px) {
    bottom: 130px;
    width: auto;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 0 24px;
    color: $result-top-alert-text-color;
    background: $result-top-alert-bg-color;
    border-radius: 8px;
    box-shadow: 0px 4px 20px 0px rgba(25, 60, 77, 0.20);
  }
}
.result-top-alert--error {
  @include result-top-alert(#fff , #CC1D1D);
  span {
    font-size: 13px;
    @media screen and (min-width: 960px) {
      font-size: 15px;
    }
  }
}
.result-top-alert--clear {
  @include result-top-alert(#000 , #FFE34F);
  span {
    font-size: 13px;
    @media screen and (min-width: 960px) {
      font-size: 15px;
    }
  }
}
.result-top-alert--urge {
  @include result-top-alert(#ffffff , #E91E63);
  span {
    font-size: 13px;
    @media screen and (min-width: 960px) {
      font-size: 15px;
    }
  }
}

/* 記録開始日（00/00）以降に入力欄が表示され、記録の入力が可能になります。 => .result-top-is-preparation */
.result-top-is-preparation {
  width: 100vw;
  margin: -12px -12px 0;
  font-size: 16px;
  background-color: #F5F5F5;

  @media screen and (min-width: 600px) {
    margin: -24px -24px 0;
  }
  @media screen and (min-width: 960px) {
    width: 100%;
    height: 40px;
    margin: 0;
    font-size: 13px;
    border-radius: 8px;
  }
}

 /* 画面全体を覆うローディング モバイルアプリ起動～歩数保存まで表示 */
.result-top-loading-mobile-app {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 10;
}

/* 初期から記載のあるもの */
.custom-alert {
  font-size: 0.9rem;
  font-weight: bold;
  padding: 3px 15px 1px 15px;
  border-radius: 3px;
}
.prizewinner-label {
  font-size:0.9rem;
  padding:3px 20px;
}
.is-not-prizewinner {
  background-color: #f5f5f5 !important;
  color: #4d4d4d;
  border: #4d4d4d solid 0.5px;
}
.is-prizewinner {
  background-color: #ffe6f0;
  color: #CC0058 !important;
  border: #CC0058 solid 0.5px;
}
</style>
